import theme from '../../base';

const tooltip = {
  background: theme.colors.neutrals.gray700,
  foreground: theme.colors.neutrals.white,
};

export default tooltip;
